import { ConnectionCubeSearchRequirements } from '../components/connections/connection-creation/search/connection-cube-search-requirements';
import { Connection } from '@3d-scene/model3d/connection';
import { IntRangeVO, PropertyValueVO, PropertyVO } from '@project/components/article/model/vo/property.vo';
import { MetaElementFeaturePropertyDef } from '@project/constants/meta-element-feature-property-def';
import { PropertyValueType } from '@project/constants/property-value-type';
import { Injectable } from '@angular/core';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';

@Injectable({ providedIn: 'root' })
export class PropertyCreator {
  constructor(private connectionInfoService: ConnectionInfoService) {}

  public createCubesSearchRequirementsByDefault(acceptingConnections: Connection[]): ConnectionCubeSearchRequirements[] {
    const searchRequirements: ConnectionCubeSearchRequirements[] = [];
    for (const cube of acceptingConnections) {
      const cubeRequirements: ConnectionCubeSearchRequirements = this.createSearchRequirementsByConnection(cube);
      searchRequirements.push(cubeRequirements);
    }
    return searchRequirements;
  }

  public createSearchRequirementsByConnection(
    acceptingConnection: Connection,
    observeCompositeArticleId: boolean = true
  ): ConnectionCubeSearchRequirements {
    const cubeRequirements: ConnectionCubeSearchRequirements = new ConnectionCubeSearchRequirements(
      this.connectionInfoService,
      acceptingConnection,
      observeCompositeArticleId
    );
    cubeRequirements.connectionRequirements = this.connectionInfoService.findRequirementPropertiesByConnection(acceptingConnection);
    return cubeRequirements;
  }

  public createDistancePropertyWithRangeValue(leftRangeDistance: number, rightRangeDistance: number): PropertyVO {
    const deltaDistanceProperty: PropertyVO = new PropertyVO();
    deltaDistanceProperty.name = MetaElementFeaturePropertyDef.DISTANCE;
    deltaDistanceProperty.values = [];

    const deltaDistanceIntValue: PropertyValueVO = new PropertyValueVO();
    deltaDistanceIntValue.type = PropertyValueType.INTRANGE;
    // there is an always a certain unprecision when dealing with measurements taken from 3d-objects in away3d
    // at the moment i think it is best to just provide int-valued distance here, which is also rounded from the float-valued measurement
    // Rounding takes care of unprecision in floating points, problematic example in PNG-245
    const deltaDistanceIntRangeValue: IntRangeVO = new IntRangeVO(Math.round(leftRangeDistance), Math.round(rightRangeDistance));
    deltaDistanceIntValue.intRange = deltaDistanceIntRangeValue;
    deltaDistanceProperty.values.push(deltaDistanceIntValue);

    return deltaDistanceProperty;
  }
}
